import { Route } from '@angular/router';
import { MunicipalitiesComponent } from './municipalities/municipalities.component';
import { TendersComponent } from './tenders/tenders.component';
import { UsersComponent } from './users/users.component';
export const SETTINGS_ROUTES: Route[] = [
  { path: 'municipalities', component: MunicipalitiesComponent, data: { name: 'Gemeenten' } },
  { path: 'tenders', component: TendersComponent, data: { name: 'Aanbestedingen' } },
  { path: 'users', component: UsersComponent, data: { name: 'Gebruikers' } },
  { path: '', redirectTo: 'municipalities', pathMatch: 'full' },
];
